import api from './api';

export const subscriptionService = {
    getPlans: async () => {
        return await api.get('/subscriptions/plans');
    },

    getSubscriptionStatus: async () => {
        return await api.get('/subscriptions/status');
    },

    createSubscription: async (price_id) => {
        return await api.post('/stripe/create-subscription', {
            price_id
        });
    },

    createPortalSession: async () => {
        return await api.post('/stripe/create-portal-session', {});
    },
};